import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { Room, LocalAudioTrackPublication, RemoteAudioTrackPublication } from 'twilio-video'
import uniq from 'lodash/uniq'
import selectIsLocalParticipantDialedIn from '../selectIsLocalParticipantDialedIn'
import username from '../../../lib/username'
import selectIsForcedMuted from '../selectIsForcedMuted'
import { isDialIn, isPresenter } from '../../../lib/username/username'
import getPresentersFromSeatingOrder from '../getPresentersFromSeatingOrder'

/**
 * Determines whether the current channel ID and webcast ID has fetched data successfully
 * @param state The Redux state
 */

const getEnabledTracks = (state: State): string[] => state.tracks.enabledAudioTracks
const getMutedList = (state: State): string[] => state.syncUi.mute
const getRoom = (state: State): Room | null => state.room.room

export default createSelector(
  [
    getPresentersFromSeatingOrder,
    getMutedList,
    getEnabledTracks,
    getRoom,
    selectIsLocalParticipantDialedIn,
    selectIsForcedMuted
  ],
  (presentersFromSeating,  mutedParticipants, enabledTracks, room, isLocalParticipantDialedIn, isForceMuted): (LocalAudioTrackPublication | RemoteAudioTrackPublication)[] => {

    if (!room || isLocalParticipantDialedIn || isForceMuted) return []

    const presenters = presentersFromSeating.map(({id}) => id )

    const audibleParticipants: string[] = uniq(presenters)
      .filter(_identity => !mutedParticipants.includes(username.getPureUsername(_identity)))

    const publications: (LocalAudioTrackPublication | RemoteAudioTrackPublication)[] = []

    if (audibleParticipants.includes(room.localParticipant.identity) && (isPresenter(room.localParticipant.identity) || isDialIn(room.localParticipant.identity))) {

      for (const [ , publication ] of room.localParticipant.audioTracks.entries()) {

        if (enabledTracks.includes(publication.trackSid)) publications.push(publication)

      }

    }

    for (const [ , participant ] of room.participants.entries()) {

      if (!isPresenter(participant.identity) && !isDialIn(participant.identity)) continue
      
      for (const [ , publication ] of participant.audioTracks.entries()) {

        publications.push(publication)

      }

    }

    return publications

  })
